/* eslint-disable */
import { GetterTree } from "vuex";
import { User } from "@/models/user";
import { Sales } from "@/models/sales";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { UserState } from "@/types/user";
import { SalesState } from "@/types/sales";

const getters: GetterTree<SalesState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new Sales();
  },
  selectItem: (state) => {
    return state.pagination
      ? state.pagination.data.map((user) => Sales.toSelectItem(user))
      : [];
  },
};

export default getters;
